






















import { Component, Prop } from "vue-property-decorator";
import Vue from 'vue';
import Chart from './Chart.vue';
import { TimeSeriesMetadata } from '../declarations/weightlifting';


@Component({
    components: {
        Chart
    }
})
class ChartTile extends Vue {
    @Prop()
    exerciseCode!: string;
    @Prop()
    exerciseName!: string;
    @Prop()
    timeSeriesMetadata!: TimeSeriesMetadata[];
    loading: boolean = true;

    constructor() {
        super();
    }

    private chartLoadedHandler() {
        this.loading = false;
    }
}

export default ChartTile;

